export default __webpack_public_path__ + "static/media/profile.f29a3c3f.svg";